const app = {
	http_Name: location.hostname === '60.191.17.178' ?
		'正式服' : location.hostname === 'bs.oudot.cn' ? '测试服' : '本地', //标签(服)
	http_url: location.hostname === 'localhost' ? 'https://bs.oudot.cn' : '/', //接口地址 测试服
	//http_url: location.hostname === 'localhost' ? 'http://60.191.17.178:9003' : '/', //接口地址 正式服
	http_URL: 'http://60.191.17.178:9003', //静态资源地址
}

export default app;